module.exports = __webpack_public_path__ + "assets/img/title-64724537.png";